import { Component, OnInit } from '@angular/core';
import { E5coreUiWorkFieldTypeDateBaseComponent } from './e5core-ui-work-field-type-date-base';

@Component({
  selector: 'e5core-ui-work-field-type-date-bootstrap',
  templateUrl: './e5core-ui-work-field-type-date-bootstrap.component.html',
  styleUrls: ['./e5core-ui-work-field-type-date-bootstrap.component.css']
})
export class E5coreUiWorkFieldTypeDateBootstrapComponent extends E5coreUiWorkFieldTypeDateBaseComponent implements OnInit {
  ngOnInit(): void {
  }
}
